"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useField = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var FormWrapper_1 = require("../components/FormWrapper");
var AnalyticsContext_1 = __importDefault(require("../context/AnalyticsContext"));
var useField = function (props) {
    var trackEvent = props.trackEvent, restProps = __rest(props, ["trackEvent"]);
    var track = react_1.default.useContext(AnalyticsContext_1.default).track;
    var translate = react_1.default.useContext(FormWrapper_1.ErrorTranslationContext);
    var _a = formik_1.useField(restProps), field = _a[0], meta = _a[1], helpers = _a[2];
    var onBlur = field.onBlur, value = field.value;
    var modifiedOnBlur = react_1.default.useMemo(function () {
        if (!trackEvent)
            return onBlur;
        return function (e) {
            onBlur(e);
            if (value) {
                track(trackEvent);
            }
        };
    }, [value, onBlur, trackEvent]);
    var modifiedField = __assign(__assign({}, field), { onBlur: modifiedOnBlur });
    var error = meta.error;
    var modifiedError = error ? translate(error) : error;
    var modifiedMeta = __assign(__assign({}, meta), { error: modifiedError });
    return [modifiedField, modifiedMeta, helpers];
};
exports.useField = useField;
